import { render, staticRenderFns } from "./JiaYing.vue?vue&type=template&id=1c3b12ba&scoped=true&"
import script from "./JiaYing.vue?vue&type=script&lang=js&"
export * from "./JiaYing.vue?vue&type=script&lang=js&"
import style0 from "./JiaYing.vue?vue&type=style&index=0&id=1c3b12ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3b12ba",
  null
  
)

export default component.exports